import { multiSelect } from 'src/common/selectors'
import i18n from '@/typescript/servicos/i18n/i18n.servico'
import { TipoEntidade } from './dominio/regrasDeFerias.interface';

interface Categoria {
  nome: string;
  id: string;
  comum: string;
  estado: string;
  entidade: TipoEntidade;
}

const categorias: Categoria[] = [
  {
    nome: i18n.t('comuns.genericos.plural.locaisDeTrabalho').toString(),
    id: 'companies',
    comum: 'companies/onlyActive',
    estado: 'regrasDeFerias/companies',
    entidade: TipoEntidade.LOCAL_DE_TRABALHO
  },
  {
    nome: i18n.t('comuns.genericos.plural.empregados').toString(),
    id: 'employees',
    comum: 'employees/onlyNotFired',
    estado: 'regrasDeFerias/employees',
    entidade: TipoEntidade.EMPREGADO
  },
  {
    nome: i18n.t('comuns.genericos.plural.grupos').toString(),
    id: 'userGroups',
    comum: 'userGroups',
    estado: 'regrasDeFerias/userGroups',
    entidade: TipoEntidade.GRUPO
  },
  {
    nome: i18n.t('comuns.genericos.plural.perfis').toString(),
    id: 'roleGroups',
    comum: 'roleGroups/onlyNotRh',
    estado: 'regrasDeFerias/roleGroups',
    entidade: TipoEntidade.PERFIL
  }
]

function estadoPadrao() {
  return {
    ...multiSelect.mapStates(['companies', 'employees', 'userGroups', 'roleGroups']),
    categorias: {
      loaded: categorias,
      selected: categorias[0]
    }
  }
}

const estado = estadoPadrao()

type Estado = typeof estado

const mutacoes = {
  ...multiSelect.mapMutations(['companies', 'employees', 'userGroups', 'roleGroups']),
  categorias: (estado: Estado, payload: { loaded: Categoria[], selected: Categoria }) => estado.categorias = payload,
  resetarEstado: (estado: Estado) => Object.assign(estado, estadoPadrao()),
}

export default {
  namespaced :true,
  state: estado,
  mutations: mutacoes
}
